import React from "react";


const ProgressBar = (props) => {

  const { completed, height } = props;
  let percentages = completed;

  const containerStyles = {
    height: 10,
    width: '100%',
    backgroundColor: "#F5DDCE",
    borderRadius: 50,
    overflow: "hidden",
  }

  const fillerStyles = {
    height: '100%',
    width: `${percentages}%`,
    backgroundColor: "#e66e3b",
    borderRadius: 'inherit',
    textAlign: 'right'
  }

  const labelStyles = {
    padding: 5,
    color: 'white',
    fontWeight: 'bold'
  }

  if (completed >= 100) {
    percentages = 100;
    fillerStyles.backgroundColor = "#6ac362";
  }

  if (height) {
    containerStyles.height = height;
  }

  



  return (
    <div className="progressBar" style={containerStyles}>
      <div style={fillerStyles}>
        <span style={labelStyles}></span>
      </div>
    </div>
  );
};

export default ProgressBar;